import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ImpressumPage from './pages/ImpressumPage';
import AGBPage from './pages/AGBPage';
import TarifCalculatorPage from './pages/TarifCalculatorPage';
import AdminBundlePage from './pages/AdminBundlePage';
import HiddenAffiliatePage from './pages/HiddenAffiliatePage';
import StromGasPage from './pages/StromGasPage';
import InternetZuhausePage from './pages/InternetZuhausePage';
import HandyvertragVoelklingenPage from './pages/HandyvertragVoelklingenPage';
import InternetSaarlandPage from './pages/InternetSaarlandPage';
import StromGasVoelklingenPage from './pages/StromGasVoelklingenPage';
import NotFoundPage from './pages/NotFoundPage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import HandyvertragSaarbrueckenPage from './pages/HandyvertragSaarbrueckenPage';
import InternetSaarlouisPage from './pages/InternetSaarlouisPage';
import StromDillingenPage from './pages/StromDillingenPage';
import Layout from './components/Layout';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/uber-uns" element={<AboutPage />} />
          <Route path="/datenschutz" element={<PrivacyPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/produkte/:category" element={<ProductsPage />} />
          <Route path="/produkt/:id" element={<ProductDetailPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/agb" element={<AGBPage />} />
          <Route path="/angebote/tarif" element={<TarifCalculatorPage />} />
          <Route path="/strom-gas" element={<StromGasPage />} />
          <Route path="/internet-zuhause" element={<InternetZuhausePage />} />
          <Route path="/handyvertrag-voelklingen" element={<HandyvertragVoelklingenPage />} />
          <Route path="/internet-anbieter-saarland" element={<InternetSaarlandPage />} />
          <Route path="/strom-gas-voelklingen" element={<StromGasVoelklingenPage />} />
          <Route path="/handyvertrag-saarbruecken" element={<HandyvertragSaarbrueckenPage />} />
          <Route path="/internet-saarlouis" element={<InternetSaarlouisPage />} />
          <Route path="/strom-dillingen" element={<StromDillingenPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />

          {/* Admin-only routes - not visible in public navigation */}
          <Route path="/admin/bundle" element={<AdminBundlePage />} />

          {/* Hidden affiliate page - not visible in public navigation */}
          <Route path="/hidden-affiliate" element={<HiddenAffiliatePage />} />

          {/* Redirect old URLs to new ones */}
          <Route path="/products/:category" element={<Navigate to="/produkte/:category" replace />} />
          <Route path="/about" element={<Navigate to="/uber-uns" replace />} />
          <Route path="/privacy" element={<Navigate to="/datenschutz" replace />} />
          <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
          <Route path="/angebote/bundle" element={<Navigate to="/angebote/tarif" replace />} />

          {/* Catch all route for 404s */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      <CookieConsent />
    </Router>
  );
}

export default App;
